const PROFILE_IMAGE_MIMES = new Set(['image/jpeg', 'image/png', 'image/webp']);
const MAX_ORIGINAL_BYTES = 10 * 1024 * 1024;
const MIN_REDUCTION_RATIO = 0.6;
const MAX_DIMENSION = 1024;

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) reject(new Error('Falha ao comprimir imagem.'));
      else resolve(blob);
    }, type, quality);
  });
}

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Arquivo de imagem inválido.'));
    };
    img.src = url;
  });
}

/**
 * Comprime imagem de perfil (mín. 60% de redução quando possível). Apenas 1 arquivo por chamada.
 */
export async function compressProfileImage(file) {
  if (!file || !(file instanceof Blob)) {
    throw new Error('Selecione uma imagem.');
  }
  if (!PROFILE_IMAGE_MIMES.has(file.type)) {
    throw new Error('Formato não permitido. Use JPEG, PNG ou WebP.');
  }
  if (file.size > MAX_ORIGINAL_BYTES) {
    throw new Error('Imagem muito grande. Máximo 10MB.');
  }

  const originalSize = file.size;
  const targetMaxBytes = Math.max(
    32 * 1024,
    Math.floor(originalSize * (1 - MIN_REDUCTION_RATIO))
  );

  const img = await loadImage(file);
  let w = img.naturalWidth || img.width;
  let h = img.naturalHeight || img.height;
  if (!w || !h) throw new Error('Dimensões da imagem inválidas.');

  if (w > MAX_DIMENSION || h > MAX_DIMENSION) {
    if (w >= h) {
      h = Math.round((h * MAX_DIMENSION) / w);
      w = MAX_DIMENSION;
    } else {
      w = Math.round((w * MAX_DIMENSION) / h);
      h = MAX_DIMENSION;
    }
  }

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const outputMime = 'image/jpeg';
  let quality = 0.82;
  let scale = 1;

  const render = () => {
    const cw = Math.max(64, Math.round(w * scale));
    const ch = Math.max(64, Math.round(h * scale));
    canvas.width = cw;
    canvas.height = ch;
    ctx.clearRect(0, 0, cw, ch);
    ctx.drawImage(img, 0, 0, cw, ch);
  };

  render();
  let blob = await canvasToBlob(canvas, outputMime, quality);

  while (blob.size > targetMaxBytes && (quality > 0.35 || scale > 0.45)) {
    if (quality > 0.35) {
      quality = Math.max(0.35, quality - 0.08);
    } else {
      scale = Math.max(0.45, scale - 0.1);
      render();
    }
    blob = await canvasToBlob(canvas, outputMime, quality);
  }

  if (blob.size > MAX_ORIGINAL_BYTES) {
    throw new Error('Não foi possível comprimir a imagem abaixo de 10MB.');
  }

  const baseName = String(file.name || 'avatar').replace(/\.[^.]+$/i, '') || 'avatar';
  return new File([blob], `${baseName}.jpg`, { type: outputMime, lastModified: Date.now() });
}

export const PROFILE_IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp';
